import { render, staticRenderFns } from "./BlockType14List.vue?vue&type=template&id=01f2ae22&scoped=true"
import script from "./BlockType14List.vue?vue&type=script&lang=ts"
export * from "./BlockType14List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType14List.vue?vue&type=style&index=0&id=01f2ae22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2ae22",
  null
  
)

export default component.exports